<template>
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <div class="my-2">
          <button type="button" class="btn btn-lg btn-primary" v-if="!isCameraOpen" @click="toggleCamera">Open Scanner</button>
          <button v-else type="button" class="btn btn-lg btn-secondary" @click="toggleCamera">Close Scanner</button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <StreamBarcodeReader @loaded="onLoaded" @decode="onDecode" v-if="isCameraOpen" class="my-2"></StreamBarcodeReader>
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <div class="my-2" v-if="scaned"><span class="text-success">ean:</span><span class="font-weight-bold"> {{ scaned }} </span></div>
      </div>
    </div>

    <ProductView @setFocus="setFocus()"/>
  </div>
</template>

<script>
  import { StreamBarcodeReader } from 'vue-barcode-reader'
  import ProductView from '@/components/ProductView'
  import { mapMutations, mapActions } from 'vuex'

  export default {
    name: 'ProductFormCamera',

    components: {
      ProductView,
      StreamBarcodeReader
    },

    data () {
      return {
        scaned: '',
        isCameraOpen: false
      }
    },

    mounted () {
      // this.onDecode('9788375059823')
    },

    methods: {
      ...mapMutations(['updateScaned']),
      ...mapActions(['getProduct']),
      toggleCamera () {
        if (this.isCameraOpen) {
          this.isCameraOpen = false
        } else {
          this.isCameraOpen = true
        }
      },
      onLoaded () {
      },
      async onDecode (result) {
        this.isCameraOpen = false
        this.scaned = result
        this.$store.commit('updateScaned', {scaned: this.scaned})
        this.$store.dispatch('getProduct')
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProductFormCamera.vue